import Swiper, { Navigation, Controller, Thumbs, A11y, Scrollbar } from 'swiper';
Swiper.use([Navigation, Controller, Thumbs, A11y, Scrollbar]);

const sliders = (Splide) => {
    const singleArticleSwiper = document.getElementsByClassName('slider-visualisations--large')[0];
    const singleThumbnailSwiper = document.getElementsByClassName("slider-visualisations__thumbnails")[0];
    const galleryBtns = document.querySelectorAll("[data-gallery='visualisations']");

    if (singleArticleSwiper && singleThumbnailSwiper) {
        const sliderVisualisations = new Splide('.slider-visualisations--large', {
            rewind: true,
            pagination: false,
            arrows: false,
        });

        const sliderVisualisationsThumbnails = new Splide(".slider-visualisations__thumbnails", {
            fixedWidth  : 85,
            pagination: false,
            rewind: true,
            isNavigation: true,
        });

        sliderVisualisations.sync(sliderVisualisationsThumbnails);
        sliderVisualisations.mount();
        sliderVisualisationsThumbnails.mount();

        sliderVisualisations.on("active", function() {
            for (let i = 0; i < galleryBtns.length; i++) {
                galleryBtns[i].dataset.index = sliderVisualisations.index;
            }
        });
    }

    const swiperLastAdded = document.querySelector(".last-added__swiper.swiper-container");
    swiperLastAdded && new Swiper(".last-added__swiper.swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 30,
    })

    const swiperComparison = document.querySelector(".comparison__items.swiper-container");
    swiperComparison && new Swiper(".comparison__items.swiper-container", {
        slidesPerView: "auto",
        spaceBetween: 0,
        // slidesOffsetAfter: swiperComparison.getBoundingClientRect().width - 290,
        navigation: {
            prevEl: ".comparison__prev",
            nextEl: ".comparison__next"
        },
        // breakpoints: {
        //     420: {
        //         slidesOffsetAfter: swiperComparison.getBoundingClientRect().width - 360,
        //     }
        // }
    });

    const splideSubscription = document.querySelector(".subscription-splide");
    if (splideSubscription) {
        const splide = new Splide(".subscription-splide", {autoWidth: true, gap: 8, pagination: false});
        splide.mount();
    }
    const categoriesSlider = document.querySelector(".categories-hp__items");
    if (categoriesSlider) {
        const categoriesSwiper = new Swiper(categoriesSlider, {
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
                prevEl: ".categories-hp__prev",
                nextEl: ".categories-hp__next"
            }
        });
    }
}

export default sliders;
